import React, { useState } from "react";

function MorthProject() {
  const [currentTab, setCurrentTab] = useState("RFP");
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header_space">MoRTH Assisted VTMS & PIS Project</div>
        <div class="bottom-highlight">
          <span
            className={`${currentTab == "RFP" ? "border-highlight" : ""}`}
            onClick={() => setCurrentTab("RFP")}
          >
            RFP
          </span>
          <span
            className={`${
              currentTab == "Ammendment" ? "border-highlight" : ""
            }`}
            onClick={() => setCurrentTab("Ammendment")}
          >
            Ammendment
          </span>
        </div>

        {currentTab == "RFP" && (
          <div class="main-container">
            <div class="main-header">
              <div class="report-item-list-rfp">
                <ol>
                  <li>Functional & Technical requirements</li>
                  <li>General Instruction & Commercial Specifications</li>
                  <li>Operational & Legal requirements</li>
                </ol>
              </div>
            </div>
          </div>
        )}

        {currentTab == "Ammendment" && (
          <div class="main-container">
            <div class="main-header">
              <div class="report-item-list-rfp">
                <ol>
                  <li>VTMS Ammendement 1</li>
                  <li>VTMS Ammendement 2</li>
                  <li>VTMS Ammendement 3</li>
                </ol>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MorthProject;
